import { createRouter, createWebHistory } from "vue-router";


const routes = [

  { path: "/auth", name: "auth", component: () => import("_views/auth/login.vue"), meta: { auth: false, cache: false }, },
  { path: "/auth/new", name: "auth:new", component: () => import("_views/auth/login.vue"), meta: { auth: false, cache: false }, },
  { path: "/auth/login", name: "auth:login", component: () => import("_views/auth/login.vue"), meta: { auth: false, cache: false }, },
  { path: '/auth/logout', name: 'auth:logout', component: () => import('_views/auth/logout.vue'), meta: { auth: false, cache: false } },
  { path: '/auth/logout/:user_id', name: 'auth:logout:user_id', component: () => import('_views/auth/logout.vue'), meta: { auth: false, cache: false } },
  { path: "/auth/register", name: "auth:register", component: () => import("_views/auth/login.vue"), meta: { auth: false, cache: false }, },
  { path: "/auth/forgot", name: "auth:forgot", component: () => import("_views/auth/forgot.vue"), meta: { auth: false, cache: false }, },
  { path: "/auth/code", name: "auth:code", component: () => import("_views/auth/code.vue"), meta: { auth: false, cache: false }, },
  { path: "/auth/setPassword", name: "auth:setPassword", component: () => import("_views/auth/setPassword.vue"), meta: { auth: true, cache: false }, },

  { path: '/settings', name: 'settings', component: () => import('_views/settings/Index.vue'), meta: { auth: true, cache: false }, },
  { path: '/settings/roles', name: 'settings:roles', component: () => import('_views/settings/roles/Index.vue'), meta: { auth: true, cache: false }, },
  { path: '/settings/users', name: 'settings:users', component: () => import('_views/settings/users/Index.vue'), meta: { auth: true, cache: false }, },
  { path: '/settings/apis', name: 'settings:apis', component: () => import('_views/settings/apis/Index.vue'), meta: { auth: true, cache: false }, },
  { path: '/settings/credits', name: 'settings:credits', component: () => import('_views/settings/credits/Index.vue'), meta: { auth: true, cache: false }, },


  { path: '/agents', name: 'agents', component: () => import('_views/agents/Index.vue'), meta: { auth: true, cache: false }, },
  { path: '/agents/:id', name: 'agents:id', component: () => import('_views/agents/Show.vue'), meta: { auth: true, cache: false }, },

  { path: '/studio', name: 'studio', component: () => import('_views/studio/Index.vue'), meta: { auth: true, cache: false }, },

  { path: '/virtual-tryon', name: 'virtual-tryon', component: () => import('_views/virtual-tryon/Index.vue'), meta: { auth: true, cache: false, requiredModule: 'concierge_aplicativos_provador_virtual' }, },
  { path: '/virtual-tryon/:id', name: 'virtual-tryon:id', component: () => import('_views/virtual-tryon/Index.vue'), meta: { auth: true, cache: false, requiredModule: 'concierge_aplicativos_provador_virtual' }, },

  { path: '/carrinho', name: 'carrinho', component: () => import('_views/carrinho/Index.vue'), meta: { auth: true, cache: false, requiredModule: 'concierge_aplicativos_carrinho' }, },
  { path: '/carrinho/:id', name: 'carrinho:id', component: () => import('_views/carrinho/Index.vue'), meta: { auth: true, cache: false, requiredModule: 'concierge_aplicativos_carrinho' }, },
  { path: '/carrinho/:id/produtos', name: 'carrinho:produtos', component: () => import('_views/carrinho/Products.vue'), meta: { auth: true, cache: false, requiredModule: 'concierge_aplicativos_carrinho' }, },

  { path: '/botCreator', name: 'botCreator', component: () => import('_views/botCreator/Index.vue'), meta: { auth: true, cache: false, requiredModule: 'concierge_automacoes' }, },
  { path: '/botCreator/:id', name: 'botCreator:id', component: () => import('_views/botCreator/Show.vue'), meta: { auth: true, cache: false, requiredModule: 'concierge_automacoes' }, },

  { path: '/chat/', name: 'chat', component: () => import('_views/chat/Index.vue'), meta: { auth: true, cache: false }, },
  { path: '/chat/:id', name: 'chat:id', component: () => import('_views/chat/Index.vue'), meta: { auth: true, cache: false }, },


  { path: '/tools/calendar', name: 'tools:calendar', component: () => import('_views/tools/calendar/Index.vue'), meta: { auth: true, cache: false, requiredModule: 'concierge_aplicativos_agendamento' }, },
  { path: '/tools/calendar/:id', name: 'tools:calendar:id', component: () => import('_views/tools/calendar/Index.vue'), meta: { auth: true, cache: false, requiredModule: 'concierge_aplicativos_agendamento' }, },

  { path: '/tools/funnel/', name: 'tools:funnel', component: () => import('_views/tools/funnel/Index.vue'), meta: { auth: true, cache: false, requiredModule: 'concierge_aplicativos_esteira' }, },
  { path: '/tools/funnel/:id/', name: 'tools:funnel:id', component: () => import('_views/tools/funnel/Index.vue'), meta: { auth: true, cache: false, requiredModule: 'concierge_aplicativos_esteira' }, },

  { path: '/agents/dashboard', name: 'agents:dashboard', component: () => import('_views/agents/Index.vue'), meta: { auth: true, cache: false }, },


  { path: '/crm', name: 'crm', component: () => import('_views/crm/Index.vue'), meta: { auth: true, cache: false }, },
  { path: '/crm/contacts', name: 'crm:contacts', component: () => import('_views/crm/contacts/Index.vue'), meta: { auth: true, cache: false }, },
  { path: '/crm/contacts/:id', name: 'crm:contacts:id', component: () => import('_views/crm/contacts/Show.vue'), meta: { auth: true, cache: false }, },
  { path: '/crm/tags', name: 'crm:tags', component: () => import('_views/crm/tags/Index.vue'), meta: { auth: true, cache: false }, },

  { path: '/report/messages', name: 'report:messages', component: () => import('_views/report/messages/Index.vue'), meta: { auth: true, cache: false }, },

  { path: "/", name: "index", component: () => import("_views/Dashboard.vue"), meta: { auth: true, cache: false }, },
  { path: "/:pathMatch(.*)*", name: "404", component: () => import("_views/Route404.vue"), meta: { auth: false }, },

  { path: '/webhook-log', name: 'webhook-log', component: () => import('_views/agents/webhook/Logs.vue'), meta: { layout: 'empty-layout', auth: true, requiredModule: 'concierge_automacoes' } },



];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, _from, next) => {

  if (to.meta.auth) {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      if (!data.token || data.token.length != 36) {
        next({ name: 'auth:login', query: { redirect: to.fullPath } });
        return;
      }

      if (to.fullPath.includes('managemnt')) {
        if (!data.owner.managemnt == 1) {
          next({ name: '404' });
        }
      }

    } catch (e) {
      next({ name: 'auth:login', query: { redirect: to.fullPath } });
      return;
    }
  }
  next();
});

router.beforeEach((to, from, next) => {
  const currentComponent = app._component;
  if (from.meta.cache && currentComponent) {
    app.config.globalProperties.$cacheManager.set(from.name, currentComponent.$options);
  }
  next();
});

router.afterEach((to, _from) => {
  //console.log("depois");

});

router.onError((error) => {
  // console.log(error);
});


export default router;
